// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__Z8U1U","unreadBadge":"styles_unreadBadge__PALYr","modalContent":"styles_modalContent__27gjF","modal":"styles_modal__3XvQS"};